export default __webpack_public_path__ + "static/i2c_logo-26a4673c98a1c1a8c75defb0e39f0384.svg";